export enum TrainingType {
  onboarding = 'onboarding',
  compliance = 'compliance',
  skills = 'skills',
  leadership = 'leadership',
  safety = 'safety',
  other = 'other',
}

export enum TrainingStatus {
  notStarted = 'not_started',
  inProgress = 'in_progress',
  completed = 'completed',
  failed = 'failed',
  expired = 'expired',
}

export interface TrainingCourse {
  id: string;
  title: string;
  description?: string;
  type: TrainingType;
  category?: string;
  duration: number; // in minutes
  content?: string; // HTML or markdown
  videoUrl?: string;
  documentUrl?: string;
  quiz?: Quiz;
  passingScore?: number; // percentage
  isRequired: boolean;
  isActive: boolean;
  tags: string[];
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Quiz {
  id: string;
  questions: QuizQuestion[];
  timeLimit?: number; // in minutes
}

export interface QuizQuestion {
  id: string;
  question: string;
  type: 'multiple_choice' | 'true_false' | 'short_answer';
  options?: string[];
  correctAnswer: string | string[];
  points: number;
}

export interface TrainingAssignment {
  id: string;
  employeeId: string;
  employeeName: string;
  courseId: string;
  courseTitle: string;
  status: TrainingStatus;
  assignedDate: Date;
  dueDate?: Date;
  startedAt?: Date;
  completedAt?: Date;
  score?: number;
  attempts: number;
  assignedBy: string;
  notes?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Certification {
  id: string;
  employeeId: string;
  employeeName: string;
  name: string;
  issuer?: string;
  issueDate: Date;
  expirationDate?: Date;
  certificateNumber?: string;
  fileUrl?: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface LearningPath {
  id: string;
  name: string;
  description?: string;
  courseIds: string[];
  isActive: boolean;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

